import React from "react";
import { Typography } from "@material-ui/core";
import { useStyles } from "./AccessTypeMethodCardStyles";
import { useTranslation } from "../../../../../hooks/useTranslation";

type AccessTypeMethodCardProps = {
  labelKey: string;
  icon: React.ReactNode;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  hasError?: boolean;
};

const AccessTypeMethodCard: React.FC<AccessTypeMethodCardProps> = ({
  labelKey,
  icon,
  selected = false,
  onClick,
  disabled = false,
  hasError = false,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={[
        classes.button,
        selected ? classes.buttonSelected : "",
        hasError && !selected ? classes.buttonError : "",
      ].filter(Boolean).join(" ")}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={classes.icon}>{icon}</span>
      <Typography className={classes.label}>{t(labelKey)}</Typography>
    </button>
  );
};

export default AccessTypeMethodCard;
